var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-container"},[_c('button',{class:{ enabled: _vm.value, disabled: !_vm.value },on:{"click":_vm.inputToggled}},[_vm._v(" "+_vm._s(_vm.value ? _vm.enabledText : _vm.disabledText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }